import React, { useCallback, useEffect } from 'react';
import Helmet from 'react-helmet';

import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Button, Message, MessageButtonsWrapper, PageContent } from '../../../components/UI';
import { Utils } from '../../../services';
import { UserTicketsList } from '../../../components/ticketV1';
import { useRoutesHelper } from '../../../helpers/routesHelper';
import { Routes } from '../../../store/routes';
import { useDispatch, useSelector } from '../../../configureStore';

const UserTicketsPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getProfileRoute } = useRoutesHelper();

  const isInitializing = useSelector((state) => state.app.isInitializing);
  const isAuthorized = useSelector((state) => state.app.isAuthorized);
  const user = useSelector((state) => state.userV1);
  const tickets = useSelector((state) => state.userTicketsV1);

  useEffect(() => {
    if (!isAuthorized || !user.phoneNumberConfirmed) {
      navigate(getProfileRoute());
      return;
    }
  }, [isAuthorized, user?.phoneNumberConfirmed]);

  const cancelTicket = useCallback(
    (ticketId: string): any => {
      // dispatch(cancelSellTicket(ticketId));
    },
    [dispatch]
  );

  if (isInitializing || !user) {
    return null;
  }

  return (
    <PageContent noPadding>
      <Helmet>
        <title>{Utils.toPageTitle(t('Profile.MyTickets'))}</title>
      </Helmet>
      {!!tickets.length && (
        <UserTicketsList tickets={tickets} cancelSellTicket={cancelTicket} go={(url) => navigate(url)} />
      )}
      {!tickets.length && (
        <Message
          title={t('MyTickets.NoTickets')}
          description={t('MyTickets.NoTicketsDescription')}
          renderButtons={() => (
            <MessageButtonsWrapper>
              <Button title={t('MyTickets.AllEvents')} onClick={() => navigate(Routes.Main)}>
                {t<string>('MyTickets.AllEvents')}
              </Button>
            </MessageButtonsWrapper>
          )}
        />
      )}
    </PageContent>
  );
};

export default UserTicketsPage;
